export function getContextItemId() {
    return document.getElementsByTagName('body')[0].dataset.itemId;
}
